import '../App.scss';

const centerSideBackTextMove = () => {
  return (
    <div className="centerSideBackTextMove">
        <span>#xkupriyanov.ru</span>
    </div>
  );
}

export default centerSideBackTextMove;